export const PATIENT_HEADER_TOP_LEVEL_ID = 'patient-header';
